webpackJsonp([19],{

/***/ 1520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__ = __webpack_require__(1826);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ece944_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__ = __webpack_require__(2127);
function injectStyle (ssrContext) {
  __webpack_require__(2125)
}
var normalizeComponent = __webpack_require__(948)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73ece944"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ece944_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1535);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_023f034c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1543);
function injectStyle (ssrContext) {
  __webpack_require__(1541)
}
var normalizeComponent = __webpack_require__(948)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-023f034c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_023f034c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: function showDialog(newVal, oldVal) {}
    },
    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    }
});

/***/ }),

/***/ 1534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1533);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95abfa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1540);
function injectStyle (ssrContext) {
  __webpack_require__(1538)
}
var normalizeComponent = __webpack_require__(948)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f95abfa4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95abfa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1498)("5ce10168", content, true, {});

/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1497)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-f95abfa4]{position:fixed;z-index:10;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-f95abfa4]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.modal-content[data-v-f95abfa4]{background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-f95abfa4]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-f95abfa4]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-f95abfa4]:focus,.close[data-v-f95abfa4]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-f95abfa4]{max-width:30%}#mdiv[data-v-f95abfa4]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-f95abfa4]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-f95abfa4]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAChB,WAAY,AACZ,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,gCACI,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-f95abfa4] {\n    position: fixed;\n    z-index: 10;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-f95abfa4] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.modal-content[data-v-f95abfa4] {\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-f95abfa4] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-f95abfa4] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-f95abfa4]:hover,\n.close[data-v-f95abfa4]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-f95abfa4] {\n    max-width: 30%;\n}\n.modal-slot[data-v-f95abfa4] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-f95abfa4] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-f95abfa4] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-f95abfa4] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1541:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1542);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1498)("51d8e565", content, true, {});

/***/ }),

/***/ 1542:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1497)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-023f034c]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-023f034c] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-023f034c]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      required: true,
      default: ''
    },
    placeholder: {
      type: String,
      default: null,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    inputClass: {
      type: String,
      required: false
    },
    titleClass: {
      type: String,
      default: '',
      required: false
    },
    maxLength: {
      type: Number,
      required: false,
      default: 100
    },
    valueType: {
      type: String,
      required: false
    },
    errorMode: {
      type: String,
      default: ''
    },
    onlyNumbersWithNegatives: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      this.myValue = newVal;
    }
  },
  data: function data() {
    return {
      myValue: this.value
    };
  },

  computed: {
    classDef: function classDef() {
      return this.errorMode === '' ? 'input pl-2  ' + this.inputClass : 'input pl-2 error ' + this.inputClass;
    },
    titleDef: function titleDef() {
      return this.titleClass === '' ? 'title mt-3' : this.titleClass + ' mt-3';
    }
  },
  methods: {
    onChange: function onChange(evt) {
      this.$emit("onChange", evt.target.value);
    }
  }
});

/***/ }),

/***/ 1591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__ = __webpack_require__(1559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1491b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__ = __webpack_require__(1596);
function injectStyle (ssrContext) {
  __webpack_require__(1592)
  __webpack_require__(1594)
}
var normalizeComponent = __webpack_require__(948)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e1491b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1491b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1592:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1593);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1498)("15b7d214", content, true, {});

/***/ }),

/***/ 1593:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1497)(true);
// imports


// module
exports.push([module.i, "input:disabled{background:#f1f1f1}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/TextField.vue"],"names":[],"mappings":"AACA,eACE,kBAAoB,CACrB","file":"TextField.vue","sourcesContent":["\ninput:disabled {\n  background: #f1f1f1;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1595);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1498)("08bb99e4", content, true, {});

/***/ }),

/***/ 1595:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1497)(true);
// imports


// module
exports.push([module.i, ".input[data-v-3e1491b2]{border-radius:5px;color:#000}input[data-v-3e1491b2]::-webkit-input-placeholder{color:#0095b2}input[data-v-3e1491b2]::-moz-placeholder{color:#0095b2}input[data-v-3e1491b2]::-ms-input-placeholder{color:#0095b2}input[data-v-3e1491b2]::placeholder{color:#0095b2}input[data-v-3e1491b2]::-webkit-inner-spin-button,input[data-v-3e1491b2]::-webkit-outer-spin-button{-webkit-appearance:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/TextField.vue"],"names":[],"mappings":"AACA,wBACE,kBAAmB,AACnB,UAAa,CACd,AACD,kDACE,aAAwB,CACzB,AACD,yCACE,aAAwB,CACzB,AACD,8CACE,aAAwB,CACzB,AACD,oCACE,aAAwB,CACzB,AACD,oGAEI,uBAAyB,CAC5B","file":"TextField.vue","sourcesContent":["\n.input[data-v-3e1491b2] {\n  border-radius: 5px;\n  color: black;\n}\ninput[data-v-3e1491b2]::-webkit-input-placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::-moz-placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::-ms-input-placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::-webkit-outer-spin-button,\ninput[data-v-3e1491b2]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{class:_vm.titleDef},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),((_vm.valueType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myValue),expression:"myValue"}],class:_vm.classDef,attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"oninput":"this.value = this.value.slice(0, this.maxLength)","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.myValue)?_vm._i(_vm.myValue,null)>-1:(_vm.myValue)},on:{"change":[function($event){var $$a=_vm.myValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.myValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.myValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.myValue=$$c}},_vm.onChange]}}):((_vm.valueType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myValue),expression:"myValue"}],class:_vm.classDef,attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"oninput":"this.value = this.value.slice(0, this.maxLength)","type":"radio"},domProps:{"checked":_vm._q(_vm.myValue,null)},on:{"change":[function($event){_vm.myValue=null},_vm.onChange]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myValue),expression:"myValue"}],class:_vm.classDef,attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"oninput":"this.value = this.value.slice(0, this.maxLength)","type":_vm.valueType},domProps:{"value":(_vm.myValue)},on:{"change":_vm.onChange,"input":function($event){if($event.target.composing){ return; }_vm.myValue=$event.target.value}}}),_vm._v(" "),(_vm.errorMode !== '')?_c('p',{staticClass:"error",staticStyle:{"font-size":"13px","border":"none","color":"rgb(218, 97, 97)"}},[_vm._v(_vm._s(_vm.errorMode))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TextField__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal__ = __webpack_require__(1534);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['systemName', 'systemId'],
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_2__components_TextField__["a" /* default */],
    Button: __WEBPACK_IMPORTED_MODULE_3__components_Button__["a" /* default */]
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var systemId, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                systemId = this.$route.params.systemId;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_0" /* getContactInfo */])(systemId);

              case 3:
                data = _context.sent;


                if (data.farmName === undefined) {
                  this.data = new Object();
                  this.data.farmName = '';
                  this.data.farmCountry = '';
                  this.data.farmAddress = '';
                  this.data.contactPersonFirstName = '';
                  this.data.contactPersonLastName = '';
                  this.data.contactPersonEmail = '';
                  this.data.contactPersonPhoneNumber = '';
                  this.data.contactPersonResponsibility = '';
                  this.data.farmOwnerFirstName = '';
                  this.data.farmOwnerLastName = '';
                  this.data.farmOwnerEmail = '';
                  this.data.farmOwnerPhoneNumber = '';
                  this.data.farmOwnerResponsibility = '';
                  this.data.isPCUpdate = true;
                } else {
                  this.data = data;
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _ref.apply(this, arguments);
      }

      return getData;
    }(),

    isFarmInfoNameValid: function isFarmInfoNameValid(value) {
      if (value.length > 30) {
        this.connectionFarmInfoError.farmName = 'Farm name is too long. Maximum 30 characters';
      } else {
        this.connectionFarmInfoError.farmName = '';
        this.data.farmName = value;
      }
    },
    isFarmInfoCountryValid: function isFarmInfoCountryValid(value) {
      if (value.length > 255) {
        this.connectionFarmInfoError.farmCountry = 'Farm country is too long. Maximum 255 characters';
      } else {
        this.connectionFarmInfoError.farmCountry = '';
        this.data.farmCountry = value;
      }
    },
    isFarmInfoAddressValid: function isFarmInfoAddressValid(value) {
      if (value.length > 255) {
        this.connectionFarmInfoError.farmAddress = 'Farm address is too long. Maximum 255 characters';
      } else {
        this.connectionFarmInfoError.farmAddress = '';
        this.data.farmAddress = value;
      }
    },
    isContactPersonFirstNameValid: function isContactPersonFirstNameValid(value) {
      if (value.length > 255) {
        this.connectionContactPersonError.firstName = 'Contact person first name is too long. Maximum 255 characters';
      } else {
        this.connectionContactPersonError.firstName = '';
        this.data.contactPersonFirstName = value;
      }
    },
    isContactPersonLastNameValid: function isContactPersonLastNameValid(value) {
      if (value.length > 255) {
        this.connectionContactPersonError.lastName = 'Contact person last name is too long. Maximum 255 characters';
      } else {
        this.connectionContactPersonError.lastName = '';
        this.data.contactPersonLastName = value;
      }
    },
    isContactPersonEmailValid: function isContactPersonEmailValid(value) {
      value = value.trim();
      if (!this.emailRegex.test(value)) {
        this.connectionContactPersonError.email = 'Contact person e-mail invalid format';
      } else {
        this.connectionContactPersonError.email = '';
        this.data.contactPersonEmail = value;
      }
    },
    isContactPersonPhoneNumberValid: function isContactPersonPhoneNumberValid(value) {
      if (value.length > 255) {
        this.connectionContactPersonError.phoneNumber = 'Contact person phone number is too long. Maximum 255 characters';
      } else {
        this.connectionContactPersonError.phoneNumber = '';
        this.data.contactPersonPhoneNumber = value;
      }
    },
    isContactPersonResponsibilityValid: function isContactPersonResponsibilityValid(value) {
      if (value.length > 255) {
        this.connectionContactPersonError.responsibility = 'Contact person responsibility is too long. Maximum 255 characters';
      } else {
        this.connectionContactPersonError.responsibility = '';
        this.data.contactPersonResponsibility = value;
      }
    },
    isFarmOwnerFirstNameValid: function isFarmOwnerFirstNameValid(value) {
      if (value.length > 255) {
        this.connectionFarmOwnerError.firstName = 'Farm owner first name is too long. Maximum 255 characters';
      } else {
        this.connectionFarmOwnerError.firstName = '';
        this.data.farmOwnerFirstName = value;
      }
    },
    isFarmOwnerLastNameValid: function isFarmOwnerLastNameValid(value) {
      if (value.length > 255) {
        this.connectionFarmOwnerError.lastName = 'Farm owner last name is too long. Maximum 255 characters';
      } else {
        this.connectionFarmOwnerError.lastName = '';
        this.data.farmOwnerLastName = value;
      }
    },
    isFarmOwnerEmailValid: function isFarmOwnerEmailValid(value) {
      value = value.trim();
      if (!this.emailRegex.test(value)) {
        this.connectionFarmOwnerError.email = 'Farm owner e-mail invalid format';
      } else {
        this.connectionFarmOwnerError.email = '';
        this.data.farmOwnerEmail = value;
      }
    },
    isFarmOwnerPhoneNumberValid: function isFarmOwnerPhoneNumberValid(value) {
      if (value.length > 255) {
        this.connectionFarmOwnerError.phoneNumber = 'Farm owner phone number is too long. Maximum 255 characters';
      } else {
        this.connectionFarmOwnerError.phoneNumber = '';
        this.data.farmOwnerPhoneNumber = value;
      }
    },
    isFarmOwnerResponsibilityValid: function isFarmOwnerResponsibilityValid(value) {
      if (value.length > 255) {
        this.connectionFarmOwnerError.responsibility = 'Farm owner responsibility is too long. Maximum 255 characters';
      } else {
        this.connectionFarmOwnerError.responsibility = '';
        this.data.farmOwnerResponsibility = value;
      }
    },
    save: function save() {
      this.checkFarmInfo();
      this.checkContactPerson();
      this.checkFarmOwner();

      if (this.connectionFarmInfoError.farmName.length === 0 && this.connectionFarmInfoError.farmCountry.length === 0 && this.connectionFarmInfoError.farmAddress.length === 0 && this.connectionFarmOwnerError.firstName.length === 0 && this.connectionFarmOwnerError.lastName.length === 0 && this.connectionFarmOwnerError.email.length === 0 && this.connectionFarmOwnerError.responsibility.length === 0 && this.connectionFarmOwnerError.phoneNumber.length === 0 && this.connectionContactPersonError.firstName.length === 0 && this.connectionContactPersonError.lastName.length === 0 && this.connectionContactPersonError.email.length === 0 && this.connectionContactPersonError.responsibility.length === 0 && this.connectionContactPersonError.phoneNumber.length === 0) {
        this.data.systemId = this.$route.params.systemId;
        // console.log(this.data);
        Object(__WEBPACK_IMPORTED_MODULE_4__api__["_87" /* updateContactInfo */])(this.data);
        this.$store.dispatch('show_confirm');
      }
    },
    checkFarmInfo: function checkFarmInfo() {
      //  console.log(this.data);
      if (this.data.farmName.length === 0) this.connectionFarmInfoError.farmName = "Farm info name is required";
      if (this.data.farmCountry.length === 0) this.connectionFarmInfoError.farmCountry = "Farm info country is required";
      if (this.data.farmAddress.length === 0) this.connectionFarmInfoError.farmAddress = "Farm info address is required";
    },
    checkContactPerson: function checkContactPerson() {
      if (this.data.contactPersonFirstName.length === 0) this.connectionContactPersonError.firstName = "Contact person first name is required";
      if (this.data.contactPersonLastName.length === 0) this.connectionContactPersonError.lastName = "Contact person last name is required";
      if (this.data.contactPersonEmail.length === 0) this.connectionContactPersonError.email = "Contact person e-mail is required";
      if (isNaN(this.data.contactPersonPhoneNumber) || this.data.contactPersonPhoneNumber === '') this.connectionContactPersonError.phoneNumber = "Contact person phone number is required";
      if (this.data.contactPersonResponsibility.length === 0) this.connectionContactPersonError.responsibility = "Contact person responsibility is required";
    },
    checkFarmOwner: function checkFarmOwner() {
      if (this.data.farmOwnerFirstName.length === 0) this.connectionFarmOwnerError.firstName = "Farm owner first name is required";
      if (this.data.farmOwnerLastName.length === 0) this.connectionFarmOwnerError.lastName = "Farm owner last name is required";
      if (this.data.farmOwnerEmail.length === 0) this.connectionFarmOwnerError.email = "Farm owner e-mail is required";
      if (isNaN(this.data.farmOwnerPhoneNumber) || this.data.farmOwnerPhoneNumber === '') this.connectionFarmOwnerError.phoneNumber = "Farm owner phone number is required";
      if (this.data.farmOwnerResponsibility.length === 0) this.connectionFarmOwnerError.responsibility = "Farm owner responsibility is required";
    },
    updateChange: function updateChange() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_90" /* updatePcUpdate */])(_this.data.systemId, _this.data.isPCUpdate);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  },
  data: function data() {
    return {
      Languages: [],
      data: {},
      emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      connectionFarmInfoError: {
        farmName: "",
        farmCountry: "",
        farmAddress: ""
      },
      connectionContactPersonError: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        responsibility: ""
      },
      connectionFarmOwnerError: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        responsibility: ""
      }
    };
  }
});

/***/ }),

/***/ 2125:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2126);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1498)("65a80a9e", content, true, {});

/***/ }),

/***/ 2126:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1497)(true);
// imports


// module
exports.push([module.i, ".checkbox-title[data-v-73ece944]{margin-left:10px;margin-bottom:0;line-height:40px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/ContactForm.vue"],"names":[],"mappings":"AACA,iCACI,iBAAkB,AAClB,gBAAmB,AACnB,gBAAkB,CACrB","file":"ContactForm.vue","sourcesContent":["\n.checkbox-title[data-v-73ece944] {\n    margin-left: 10px;\n    margin-bottom: 0px;\n    line-height: 40px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('div',{staticStyle:{"float":"right"}},[_c('label',{staticClass:"cont",attrs:{"for":"updateCheckbox"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.isPCUpdate),expression:"data.isPCUpdate"}],attrs:{"type":"checkbox","id":"updateCheckbox"},domProps:{"checked":Array.isArray(_vm.data.isPCUpdate)?_vm._i(_vm.data.isPCUpdate,null)>-1:(_vm.data.isPCUpdate)},on:{"change":[function($event){var $$a=_vm.data.isPCUpdate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.data, "isPCUpdate", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.data, "isPCUpdate", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.data, "isPCUpdate", $$c)}},_vm.updateChange]}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('p',{staticClass:"semi-bold checkbox-title"},[_vm._v("PC update")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","width":"100%","justify-content":"space-between"}},[_c('div',{staticClass:"vertical pr-2",staticStyle:{"flex-grow":"1"}},[_c('label',{staticClass:"extra-bold header-color mb-3",staticStyle:{"font-size":"24px"}},[_vm._v("Farm info")]),_vm._v(" "),_c('TextField',{ref:"farmInfoNameInput",attrs:{"maxLength":30,"inputClass":"form-input","title":"Farm Name","errorMode":_vm.connectionFarmInfoError.farmName},on:{"onChange":_vm.isFarmInfoNameValid},model:{value:(_vm.data.farmName),callback:function ($$v) {_vm.$set(_vm.data, "farmName", $$v)},expression:"data.farmName"}}),_vm._v(" "),_c('TextField',{ref:"farmInfoCountryInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Farm Country","errorMode":_vm.connectionFarmInfoError.farmCountry},on:{"onChange":_vm.isFarmInfoCountryValid},model:{value:(_vm.data.farmCountry),callback:function ($$v) {_vm.$set(_vm.data, "farmCountry", $$v)},expression:"data.farmCountry"}}),_vm._v(" "),_c('TextField',{ref:"farmInfoAddressInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Farm Address","errorMode":_vm.connectionFarmInfoError.farmAddress},on:{"onChange":_vm.isFarmInfoAddressValid},model:{value:(_vm.data.farmAddress),callback:function ($$v) {_vm.$set(_vm.data, "farmAddress", $$v)},expression:"data.farmAddress"}})],1),_vm._v(" "),_c('div',{staticClass:"vertical pr-2 pl-2",staticStyle:{"flex-grow":"1"}},[_c('label',{staticClass:"extra-bold header-color mb-3",staticStyle:{"font-size":"24px"}},[_vm._v("Contact Person")]),_vm._v(" "),_c('TextField',{ref:"contactPersonFirstNameInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"First Name","errorMode":_vm.connectionContactPersonError.firstName},on:{"onChange":_vm.isContactPersonFirstNameValid},model:{value:(_vm.data.contactPersonFirstName),callback:function ($$v) {_vm.$set(_vm.data, "contactPersonFirstName", $$v)},expression:"data.contactPersonFirstName"}}),_vm._v(" "),_c('TextField',{ref:"contactPersonLastNameInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Last Name","errorMode":_vm.connectionContactPersonError.lastName},on:{"onChange":_vm.isContactPersonLastNameValid},model:{value:(_vm.data.contactPersonLastName),callback:function ($$v) {_vm.$set(_vm.data, "contactPersonLastName", $$v)},expression:"data.contactPersonLastName"}}),_vm._v(" "),_c('TextField',{ref:"contactPersonEmailInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Email","errorMode":_vm.connectionContactPersonError.email},on:{"onChange":_vm.isContactPersonEmailValid},model:{value:(_vm.data.contactPersonEmail),callback:function ($$v) {_vm.$set(_vm.data, "contactPersonEmail", $$v)},expression:"data.contactPersonEmail"}}),_vm._v(" "),_c('TextField',{ref:"contactPersonPhoneNumberInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Phone Number","valueType":"number","errorMode":_vm.connectionContactPersonError.phoneNumber},on:{"onChange":_vm.isContactPersonPhoneNumberValid},model:{value:(_vm.data.contactPersonPhoneNumber),callback:function ($$v) {_vm.$set(_vm.data, "contactPersonPhoneNumber", $$v)},expression:"data.contactPersonPhoneNumber"}}),_vm._v(" "),_c('TextField',{ref:"contactPersonResponsibilityInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Responsibility","errorMode":_vm.connectionContactPersonError.responsibility},on:{"onChange":_vm.isContactPersonResponsibilityValid},model:{value:(_vm.data.contactPersonResponsibility),callback:function ($$v) {_vm.$set(_vm.data, "contactPersonResponsibility", $$v)},expression:"data.contactPersonResponsibility"}})],1),_vm._v(" "),_c('div',{staticClass:"vertical pl-2",staticStyle:{"flex-grow":"1"}},[_c('label',{staticClass:"extra-bold header-color mb-3",staticStyle:{"font-size":"24px"}},[_vm._v("Farm Owner")]),_vm._v(" "),_c('TextField',{ref:"farmOwnerFirstNameInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"First Name","errorMode":_vm.connectionFarmOwnerError.firstName},on:{"onChange":_vm.isFarmOwnerFirstNameValid},model:{value:(_vm.data.farmOwnerFirstName),callback:function ($$v) {_vm.$set(_vm.data, "farmOwnerFirstName", $$v)},expression:"data.farmOwnerFirstName"}}),_vm._v(" "),_c('TextField',{ref:"farmOwnerLastNameInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Last Name","errorMode":_vm.connectionFarmOwnerError.lastName},on:{"onChange":_vm.isFarmOwnerLastNameValid},model:{value:(_vm.data.farmOwnerLastName),callback:function ($$v) {_vm.$set(_vm.data, "farmOwnerLastName", $$v)},expression:"data.farmOwnerLastName"}}),_vm._v(" "),_c('TextField',{ref:"farmOwnerEmailInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Email","errorMode":_vm.connectionFarmOwnerError.email},on:{"onChange":_vm.isFarmOwnerEmailValid},model:{value:(_vm.data.farmOwnerEmail),callback:function ($$v) {_vm.$set(_vm.data, "farmOwnerEmail", $$v)},expression:"data.farmOwnerEmail"}}),_vm._v(" "),_c('TextField',{ref:"farmOwnerPhoneNumberInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Phone Number","valueType":"number","errorMode":_vm.connectionFarmOwnerError.phoneNumber},on:{"onChange":_vm.isFarmOwnerPhoneNumberValid},model:{value:(_vm.data.farmOwnerPhoneNumber),callback:function ($$v) {_vm.$set(_vm.data, "farmOwnerPhoneNumber", $$v)},expression:"data.farmOwnerPhoneNumber"}}),_vm._v(" "),_c('TextField',{ref:"farmOwnerResponsibilityInput",attrs:{"maxLength":255,"inputClass":"form-input","title":"Responsibility","errorMode":_vm.connectionFarmOwnerError.responsibility},on:{"onChange":_vm.isFarmOwnerResponsibilityValid},model:{value:(_vm.data.farmOwnerResponsibility),callback:function ($$v) {_vm.$set(_vm.data, "farmOwnerResponsibility", $$v)},expression:"data.farmOwnerResponsibility"}}),_vm._v(" "),_c('Button',{attrs:{"title":"Save","buttonClass":"save-button semi-bold w-100 mt-4"},on:{"onClick":_vm.save}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.85808397ca11da7d4e64.js